import { render, staticRenderFns } from "./PlatformCheckbox.vue?vue&type=template&id=71fb1b03&"
import script from "./PlatformCheckbox.vue?vue&type=script&lang=js&"
export * from "./PlatformCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCheckbox.vue?vue&type=style&index=0&id=71fb1b03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports